import { contract, PlaceTypeKeyEnum } from '@aviv_price-pages/brand';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useLocation } from '@aviv-unified-frontend/runtime/router';
import { TrackingViewProps } from '@/entities/enums/Tracking';
import { isPlaceInsideCity } from '@/helpers/geo/places';
import { useMobileViewDetect } from '../useMobileViewDetect/useMobileViewDetect';
import { usePageLayoutContext } from '../usePageLayoutContext/usePageLayoutContext';
const getEnvironment = (env) => {
    if (env === 'live') {
        return 'prod';
    }
    return env || 'dev';
};
export const getPageTitle = (place, isMobileView, sidebarOpen) => {
    const pageTitle = `${TrackingViewProps.PRICEMAP}_${place.type}`;
    if (!isMobileView) {
        return pageTitle;
    }
    return sidebarOpen
        ? `${pageTitle}_${TrackingViewProps.INFO_VIEW}`
        : `${pageTitle}_${TrackingViewProps.MAP_VIEW}`;
};
const getCurrentCity = (place) => {
    const { typeKey, name, parents } = place;
    if (typeKey === PlaceTypeKeyEnum.MUNICIPALITY) {
        return name.full;
    }
    if (isPlaceInsideCity(typeKey)) {
        return parents?.municipality?.name.full;
    }
    return undefined;
};
export const useTrackingProps = (pageTitleError) => {
    const { language } = useLocale();
    const { pathname, search } = useLocation();
    const { isMobileView } = useMobileViewDetect();
    const { sidebarOpen: sidebarOpen, pricePageProps } = usePageLayoutContext();
    const commonProps = {
        av_url_path: pathname,
        av_environment: getEnvironment(process.env.APP_ENV),
        av_language: language,
        av_platform: TrackingViewProps.PLATFORM,
        av_site: contract.extraConfig?.trackingBrandName,
    };
    // If there is no place, we are on an error page
    if (pageTitleError) {
        return {
            ...commonProps,
            av_pagetitle: pageTitleError,
            av_category: 'error',
        };
    }
    if (!pricePageProps) {
        return;
    }
    const m = new URLSearchParams(search).get('m');
    const mediumParam = m ? m : undefined;
    return {
        ...commonProps,
        av_medium: mediumParam,
        av_pagetitle: getPageTitle(pricePageProps.pricePageContext.place, isMobileView, sidebarOpen),
        av_category: 'price_map',
        av_city: getCurrentCity(pricePageProps.pricePageContext.place),
        av_distribution_type_global: TrackingViewProps.DISTRIBUTION_TYPE_GLOBAL,
    };
};
